import { useContext, useEffect, useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Paper,
  Typography,
  Grid,
} from "@mui/material";
import {
  RecurringBookingDataGenerated,
  RecurringBookingFormConfirm,
} from "../../../services/recurringBookingInterfaces";
import dayjs from "dayjs";
import { RecurringBookingContext } from "../Context/RecurringBookingContextWrapper";

const RecurringBookingTable = (props: {
  id: number;
  pianoAppuntamenti?: RecurringBookingDataGenerated[] | null;
  SPECIALITA?: string;
  PRESTAZIONE?: string;
}) => {
  const context = useContext(RecurringBookingContext);

  const [selectedIds, setSelectedIds] = useState<string[]>([]);

  useEffect(() => {
    console.log("PIANO APPUNTAMENTI PROPS ", props.pianoAppuntamenti)
  }, [])

  useEffect(() => {
    console.log("Appuntamenti Context", context?.selectedAppointments);
    console.log({ selectedIds });
  }, [selectedIds]);

  const handleSelect = (row: any) => {
    setSelectedIds((prev) =>
      prev.includes(row.IDAPPUNTAMENTO)
        ? prev.filter((id) => id !== row.IDAPPUNTAMENTO)
        : [...prev, row.IDAPPUNTAMENTO]
    );

    const enriched = {
      ...row,
      SPECIALITA: props.SPECIALITA ?? "",
      PRESTAZIONE: props.PRESTAZIONE ?? "",
    };

    context?.setSelectedAppointments((prev) => {
      const prevSafe = Array.isArray(prev) ? prev : [];
      const exists = prevSafe.some(
        (e) => e.IDAPPUNTAMENTO === row.IDAPPUNTAMENTO
      );
      return exists
        ? prevSafe.filter((e) => e.IDAPPUNTAMENTO !== row.IDAPPUNTAMENTO)
        : [...prevSafe, enriched];
    });
  };

  useEffect(() => {
    if (
      props?.pianoAppuntamenti &&
      props.pianoAppuntamenti.length > 0 &&
      context?.selectedAppointments &&
      context?.selectedAppointments?.length < 1
    )
      handleSelectAll();

    if (
      context?.selectedAppointments &&
      context?.selectedAppointments?.length > 1
    )
      context?.selectedAppointments.forEach((e) =>
        setSelectedIds((prev) => [...prev, e.IDAPPUNTAMENTO])
      );
  }, []);

  const progressivo = String(props.id);

  const handleSelectAll = () => {
    const allRows = (props.pianoAppuntamenti ?? []).filter(
      (a) => a.PROGRESSIVOPRESTAZIONE === progressivo
    );
    const allIds = allRows.map((r) => r.IDAPPUNTAMENTO);

    const isAllSelected = allRows.every((r) =>
      selectedIds.includes(r.IDAPPUNTAMENTO)
    );

    // aggiorno gli ID selezionati solo per questo tab
    setSelectedIds((prev) => (isAllSelected ? [] : allIds));

    // ⬇️ ENRICH: aggiungi specialità/prestazione a ogni riga
    const enrichedRows = allRows.map((r) => ({
      ...r,
      SPECIALITA: props.SPECIALITA ?? "",
      PRESTAZIONE: props.PRESTAZIONE ?? "",
    }));

    // merge nel contesto, preservando altri tab
    context?.setSelectedAppointments((prev) => {
      const prevSafe = Array.isArray(prev) ? prev : [];

      // rimuovo selezioni del progressivo corrente
      const prevOther = prevSafe.filter(
        (a) => a.PROGRESSIVOPRESTAZIONE !== progressivo
      );

      if (isAllSelected) return prevOther; // deselect all di questo progressivo

      // aggiungo evitando duplicati per IDAPPUNTAMENTO
      const next = [...prevOther, ...enrichedRows];
      const seen = new Set<string>();
      return next.filter((a) => {
        const key = String(a.IDAPPUNTAMENTO);
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    });
  };

  const makeKey = (x: {
    CODICEAGENDA?: string;
    CODICERISORSA?: string;
    DATA?: string;
    ORA?: string;
    IDPRESTAZIONE?: string;
    PROGRESSIVOPRESTAZIONE?: string;
  }) =>
    [
      x.CODICEAGENDA,
      x.CODICERISORSA,
      x.DATA,
      x.ORA,
      x.IDPRESTAZIONE,
      x.PROGRESSIVOPRESTAZIONE,
    ]
      .map(String)
      .join("|");

  const selectedKeySet = useMemo(
    () => new Set((context?.selectedAppointments ?? []).map(makeKey)),
    [context?.selectedAppointments]
  );

  return (
    <>
      <Grid
        container
        paddingTop={2}
        paddingBottom={2}
        display={"flex"}
        justifyContent={"flex-start"}
      >
        <Grid item xs={12}>
          <Typography
            variant="h6"
            gutterBottom
            visibility={props.id === 1 ? "visible" : "hidden"}
          >
            Sviluppo piano appuntamenti
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography>{props.id}</Typography>
        </Grid>
      </Grid>
      <TableContainer
        component={Paper}
        sx={{
          maxHeight: "59vh",
          overflowY: "auto",
        }}
      >
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#0d3c61" }}>
              <TableCell padding="checkbox">
                <Checkbox
                  checked={
                    props.pianoAppuntamenti
                      ?.filter(
                        (app) => app.PROGRESSIVOPRESTAZIONE === String(props.id)
                      )
                      ?.every((row) =>
                        selectedIds.includes(row.IDAPPUNTAMENTO)
                      ) ?? false
                  }
                  onChange={handleSelectAll}
                  sx={{ color: "#fff" }}
                />
              </TableCell>
              <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                N.
              </TableCell>
              <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                Data Appuntamento
              </TableCell>
              <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                Medico/ Risorsa
              </TableCell>
              <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                Ora Appuntamento
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.pianoAppuntamenti
              ?.filter((e) => e.PROGRESSIVOPRESTAZIONE === String(props.id))
              ?.map((row, id) => (
                <TableRow
                  key={id}
                  sx={{
                    backgroundColor: selectedIds.includes(row.IDAPPUNTAMENTO)
                      ? "#e3f2fd"
                      : "inherit",
                  }}
                >
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={
                        selectedIds.includes(row.IDAPPUNTAMENTO) ||
                        selectedKeySet.has(makeKey(row))
                      }
                      onChange={() => handleSelect(row)}
                    />
                  </TableCell>
                  <TableCell>{id + 1}</TableCell>
                  <TableCell>{dayjs(row.DATA).format("DD/MM/YYYY")}</TableCell>
                  <TableCell>{row.CODICERISORSA}</TableCell>
                  <TableCell>{row.ORA}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default RecurringBookingTable;
